import { useState } from "react"
import Image from "components/Image"
import Map from "components/Map"
import LocationSection from "./LocationSection"
import Arrow from "public/assets/chevron-teal.svg"
import { track } from "utilities/tracking"

function Tile({ location, setHoveredLocation }) {
  return (
    <a
      href={`#${location.slug}`}
      onClick={(e) => {
        e.preventDefault()
        const el = document.querySelector(`#${location.slug}`)
        el.scrollIntoView({ behavior: "smooth" })
      }}
      onMouseEnter={() => {
        setHoveredLocation(location)
        track({ event: "hovered_location_tile", name: location.content.name })
      }}
    >
      <div className="group mx-auto my-6 grid hover:text-teal hover:shadow xl:max-w-none xl:grid-cols-4">
        <div className="relative h-[150px] sm:h-[300px] xl:col-span-1 xl:h-auto">
          <Image
            src={location?.content?.main_photo?.filename}
            alt={location?.content?.main_photo?.alt}
            fill
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
          <div className="absolute bottom-0 left-0 hidden h-[5px] w-full bg-green opacity-0 transition duration-200 ease-out group-hover:opacity-100 group-hover:ease-in xl:block"></div>
        </div>
        <div className="relative w-full bg-white px-8 py-6 xl:col-span-3">
          <div className="absolute bottom-0 left-0 h-[5px] w-full bg-green opacity-0 transition duration-300 ease-out group-hover:opacity-100 group-hover:ease-in"></div>
          <div className="absolute right-0 top-0 flex h-full w-10 items-center justify-center bg-green pl-4 opacity-0 transition duration-300 ease-out group-hover:opacity-100 group-hover:ease-in lg:w-14">
            <Arrow className="-translate-x-1/4 -rotate-90" />
          </div>
          <div className="tile-address">
            <h3 className="font-secondary text-l2">{location.content.location_name}</h3>
            <address className="max-w-xs not-italic">{location.content.map_pin.address}</address>
          </div>
        </div>
      </div>
    </a>
  )
}

export default function MapAndTileSection({ blok }) {
  const [hoveredLocation, setHoveredLocation] = useState("")
  // Only resolved location stories can be rendered by the map, tiles, and details.
  const locations = blok.locations?.filter((location) => location?.content) ?? []

  return (
    <>
      <section className="bg-stone-light">
        <div className="mx-auto max-w-[1440px] xl:flex xl:flex-row xl:gap-x-4">
          <h2 className="py-8 text-center text-teal-dark xl:hidden">{blok.title}</h2>
          <div className="h-[80dvw] md:mx-auto md:max-h-[600px] lg:basis-1/2 xl:max-h-[700px] xl:max-w-[700px]">
            <Map zoom={9} locations={locations} copyright="CHNK" hoveredLocation={hoveredLocation} />
          </div>
          <div className="basis-1/2 px-6 pb-7 lg:pt-12">
            <h2 className="hidden text-left text-teal-dark xl:block">{blok.title}</h2>
            {locations.map((location) => (
              <Tile location={location} key={location.id} setHoveredLocation={setHoveredLocation} />
            ))}
          </div>
        </div>
      </section>
      <>
        {locations.map((loc, idx) => (
          <LocationSection key={loc.id} location={loc.content} slug={loc.slug} idx={idx} />
        ))}
      </>
    </>
  )
}
